var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExitDesignMode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "-4 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8411 7.27778L20.8411 5.16667C20.8411 4.32681 20.5103 3.52136 19.9214 2.9275C19.3325 2.33363 18.5338 2 17.7009 2L5.14019 2C4.30736 2 3.50864 2.33363 2.91974 2.92749C2.33084 3.52136 2 4.32681 2 5.16667L2 17.8333C2 18.6732 2.33084 19.4786 2.91974 20.0725C3.50864 20.6664 4.30736 21 5.14019 21L17.7009 21C18.5338 21 19.3325 20.6664 19.9214 20.0725C20.5103 19.4786 20.8411 18.6732 20.8411 17.8333L20.8411 15.7222M25.8131 7.27778L30 11.5M30 11.5L25.8131 15.7222M30 11.5L11.5078 11.5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExitDesignMode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ExitDesignMode.fea4f3f26c5a7250a6467229fe4fc382.svg";